import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  Input,
  NgZone,
  Output,
  EventEmitter,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { Observable } from 'rxjs';

import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';

import { AkitaRouterQuery } from '@app/akita/router/state/router.query';

import { SearchGlassIconComponent } from '../icons/generated/search-glass/search-glass.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { InViewportModule } from 'ng-in-viewport';
import { RemoveIconComponent } from '../icons/generated/remove/remove.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-filter-box',
  templateUrl: './search-filter-box.template.html',
  styleUrls: ['./search-filter-box.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SearchGlassIconComponent,
    RemoveIconComponent,
    CommonModule,
    FormsModule,
    AsyncPipe,
    RouterModule,
    TranslocoModule,
    InViewportModule,
  ],
})
export class SearchFilterBoxComponent {
  @Input() public searchType?: string | null;
  @Output() public readonly searchValue: EventEmitter<string>;

  public query: string;
  public inFocus: boolean;
  public rtlMode: boolean;
  public isBrowser: boolean;

  @ViewChild('searchField')
  public searchFieldElement?: ElementRef | null;

  public lessThan$: Observable<ScreenSizeInfoState>;
  public biggerThan$: Observable<ScreenSizeInfoState>;
  public searchUrlFragment$: Observable<Array<string>>;

  constructor(
    private readonly zone: NgZone,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.isBrowser = this.akitaRouterQuery.isBrowser;
    this.rtlMode = false;
    this.inFocus = false;
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.query = '';

    this.searchValue = new EventEmitter();

    this.searchUrlFragment$ = this.akitaRouterQuery.selectSearchUrlFragment();
  }

  public getClearSearchQuery(): void {
    this.query = '';
    this.changeDetector.markForCheck();
    this.inFocus = false;
    this.valueChanged();
  }

  public close(): void {
    this.zone.run(() => {
      this.inFocus = false;
      this.changeDetector.markForCheck();
    });
  }

  public valueChanged(): void {
    this.searchValue.emit(this.query);
  }

  public openSearchInput(): boolean {
    if (!this.inFocus) {
      this.searchFieldElement?.nativeElement.focus();
      this.inFocus = true;
    }
    return false;
  }
}
